import { useEffect } from "react";

export default async function useAsyncEffect(effect,deps){
  useEffect(()=>{
    (()=>effect())()  
  },deps)
}